import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_item_review_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  summary: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  rating_value_avg: fromDatatype.NumericDatatypeInterface;
  total_votes: fromDatatype.IntegerDatatypeInterface;
  rating_value_editor: fromDatatype.NumericDatatypeInterface;
  rating_value_min: fromDatatype.NumericDatatypeInterface;
  review_rating_config_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_item_review_hdr_RowClass implements bl_fi_item_review_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  summary: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  rating_value_avg: fromDatatype.NumericDatatypeInterface;
  total_votes: fromDatatype.IntegerDatatypeInterface;
  rating_value_editor: fromDatatype.NumericDatatypeInterface;
  rating_value_min: fromDatatype.NumericDatatypeInterface;
  review_rating_config_guid: fromDatatype.GuidDataFieldInterface;
}
